import useSWR from 'swr';

interface Vacancy {
  id: number;
  title: string;
  subtitle: string;
  tags: string[];
  tasks: string[];
  plus: string[];
  is_active?: boolean;
}

// Хук для получения списка вакансий
export function useVacancies() {
  const { data, error, isLoading, isValidating, mutate } = useSWR<Vacancy[]>(
    '/api/vacancies/',
    {
      // Вакансии редко меняются — раз в 5 минут
      refreshInterval: 300000,
      revalidateIfStale: true,
    }
  );

  // Нормализация и фильтрация
  const vacancies = (Array.isArray(data) ? data : [])
    .map((v: any) => ({
      id: Number(v?.id) || 0,
      title: String(v?.title || '').trim(),
      subtitle: String(v?.subtitle || '').trim(),
      tags: Array.isArray(v?.tags) ? v.tags.map((x: any) => String(x || '').trim()).filter(Boolean) : [],
      tasks: Array.isArray(v?.tasks) ? v.tasks.map((x: any) => String(x || '').trim()).filter(Boolean) : [],
      plus: Array.isArray(v?.plus) ? v.plus.map((x: any) => String(x || '').trim()).filter(Boolean) : [],
    }))
    .filter((v) => v.id > 0 && v.title !== '');

  return {
    vacancies,
    isLoading,
    isValidating,
    error,
    mutate,
  };
}
